import { Controller } from "web-ui/controller"
import * as Log from "web-ui/log"

const animationDelayMilliseconds = 500;

// Connects to data-controller="modal-dialog"
export default class extends Controller {
  static events = {
    "close": "closeAndRemove",
    "cancel": "cancel",
    "turbo:submit-start": "submitStart",
    "turbo:submit-end": "submitEnd:capture"
  }

  connect() {
    this.debug("Connect")

    this.submitting = false
    this.disabledCloseButtons = []

    this.element.showModal()
  }

  disconnect() {
    this.debug("Disconnect")
  }

  closeAndRemove() {
    this.element.close()
    setTimeout(() => this.remove(), animationDelayMilliseconds)
  }

  close() {
    if (this.submitting) {
      return
    }

    this.element.close()
  }

  cancel(event) {
    if (this.submitting) {
      event.preventDefault()
    }
  }

  submitStart() {
    this.submitting = true

    this.disabledCloseButtons = Array.from(
      this.element.querySelectorAll('button[data-action*="modal-dialog#close"]:enabled')
    )

    for (const button of this.disabledCloseButtons) {
      button.disabled = true
    }
  }

  submitEnd() {
    this.submitting = false

    for (const button of this.disabledCloseButtons) {
      button.disabled = false
    }

    this.disabledCloseButtons = []
  }

  remove() {
    this.element.remove()
  }

  debug(message, data) {
    Log.debug("Modal Dialog - " + message, data)
  }
}
